module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_honor_magicbook_fr-52b19c07ea24198b6c05e03532372911.jpg";